export const environment = {
    production: false,
    serverUrl:"https://ruby-cocoon-fez.cyclic.app"
}